import Vue from 'vue'
import Store from 'store'

import ProductTile from './ProductTile.vue'

const el = '.nti-component--product-tile'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                ProductTile
            },
            template: '<ProductTile />'
        })
    }
}

export default {
    render
}